module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "solid 1px #B6B4AC",
      "margin-top": "0",
      "margin-right": "20em",
      "margin-bottom": "3em",
      "margin-left": "1em"
    }
  })]), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Illustrations"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Introduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alone in a Sea of Humanity")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Origin",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Defending the Nation")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Use_This_Book",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_The_Artwork",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Artwork: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("From Soot to Life")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song of Trusting the Heart")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APPENDICES")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. A Word’s Incredible Journey")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Layers of Meaning: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Translating Song of Trusting the Heart")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Reading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suggested Reading")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_The_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Author")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_The_Artist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Artist")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cef2874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0